import { Injectable } from "@angular/core";

@Injectable()
export class Globals {
  language: string = "french";
  language_id: number = 0;
  token: string = "";
  isAdmin: boolean = false;
  impersonating: boolean = false;
  userEmail: string = "";
  userFirstName: string = "";
  userLastName: string = "";
  userName: string = "";
  user: any = {};
  menu: any = {};
  state: any = {};
  access: any = {};
  hideNavigation: boolean = false;
}
